import * as THREE from 'three';
import { C } from '../core/palette.js';
import { cyl, sphere } from '../core/meshkit.js';

// Gary — the little green alien who runs the comic shop. Big domed head, huge
// eyes, a wobbly antenna. Build once, add .root to the scene, call update(dt).
// Lives behind the counter and bobs; nod() gives a quick approving bob.

const ALIEN = 0x8FD14F;

export class Gary {
  constructor(){
    this.root = new THREE.Group();

    // body — a small green blob
    const body = sphere(0.42, ALIEN, 0, 0.5, 0, this.root, 16);
    body.scale.set(1, 1.1, 0.9);

    // big domed head
    this.head = sphere(0.5, ALIEN, 0, 1.25, 0, this.root, 18);
    this.head.scale.set(1.1, 1, 1);

    // huge alien eyes (white almond + dark pupil)
    const eye = (x) => {
      const e = sphere(0.18, C.white, x, 1.28, 0.34, this.root, 12);
      e.scale.set(0.8, 1.2, 0.6);
      sphere(0.08, 0x1A1A22, x, 1.26, 0.46, this.root, 8);
    };
    eye(-0.2); eye(0.2);
    // tiny smile
    const mouth = cyl(0.06, 0.06, 0.03, 0x2E5A22, 0, 1.02, 0.44, this.root, 8);
    mouth.rotation.x = Math.PI/2; mouth.scale.set(1.4, 1, 0.5);

    // antenna with a glowing tip
    this.antenna = new THREE.Group();
    this.antenna.position.set(0, 1.72, 0);
    cyl(0.03, 0.03, 0.4, ALIEN, 0, 0.2, 0, this.antenna, 6);
    const bulb = sphere(0.1, C.tangerine, 0, 0.45, 0, this.antenna, 10);
    bulb.material = new THREE.MeshBasicMaterial({ color: C.tangerine });
    this.root.add(this.antenna);

    // stubby arms
    cyl(0.05, 0.05, 0.4, ALIEN, -0.42, 0.6, 0.05, this.root, 6).rotation.z = 0.7;
    cyl(0.05, 0.05, 0.4, ALIEN,  0.42, 0.6, 0.05, this.root, 6).rotation.z = -0.7;

    this.phase = Math.random() * Math.PI * 2;
    this.nodT = 0;
  }

  nod(){ this.nodT = 0.5; }

  update(dt){
    this.phase += dt * 2.2;
    this.root.position.y = Math.abs(Math.sin(this.phase)) * 0.05;
    this.antenna.rotation.z = Math.sin(this.phase * 1.6) * 0.25;   // wobble
    if (this.nodT > 0){
      this.nodT -= dt;
      this.head.rotation.x = Math.sin((0.5 - this.nodT) * Math.PI * 4) * 0.25;
    } else {
      this.head.rotation.x = Math.sin(this.phase * 0.7) * 0.05;
    }
  }
}
